import type {ReactElement} from 'react'
import {SwiperRef, SwiperSlide} from 'swiper/react'
import {useSwiper} from 'swiper/react'
import Image from 'next/image'
import React, { useState } from 'react'

interface Props {
  image: any
  index: number
  sliderIndex: number
  setSliderIndex: any
  mainRef: any
  onLoad: () => void
  loaded: boolean
}
export default function ProductThumbnailItem({
  image,
  index,
  sliderIndex,
  setSliderIndex,
  mainRef,
  onLoad,
  loaded
}: Props): ReactElement {
  const swiper = useSwiper()
  const [imageError, setImageError] = useState(false)

  return (
    <>
      {mainRef.current && (
        <div
          onClick={() => {
            mainRef.current.swiper.slideTo(index)
            setSliderIndex(index)
          }}
          className="block w-full h-[80px] lg:h-[100px] relative cursor-pointer">
          
          {/* Skeleton loader */}
          {!loaded && !imageError && (
            <div className="absolute inset-0 bg-gray-200 animate-pulse rounded-lg z-10"></div>
          )}
          
          {sliderIndex !== index && (
            <div className="product-item-slider-backdrop w-full absolute z-[5] inset-0 h-full"></div>
          )}
          
          {/* Image */}
          <img
            src={process.env.NEXT_PUBLIC_CDN_URL + '/' + image}
            className={`w-full h-full object-cover ${loaded ? 'opacity-100' : 'opacity-0'}`}
            alt={'product-image'}
            width={70}
            height={70}
            onLoad={onLoad}
            onError={() => {
              setImageError(true);
              onLoad(); // Consider it loaded even if there's an error
            }}
            style={{ transition: 'opacity 0.3s ease-in-out' }}
          />
          
          {/* Error state */}
          {imageError && (
            <div className="absolute inset-0 bg-gray-200 flex items-center justify-center z-10">
              <span className="text-gray-500 text-xs">Error</span>
            </div>
          )}
        </div>
      )}
    </>
  )
}